var map = {
	"./Avva Logo.png": 989,
	"./Bhpcl Logo.jpg": 9112,
	"./Charter Club Chile Logo.jpeg": 1560,
	"./Edamama Logo.png": 7989,
	"./Geisha Logo.jpeg": 8973,
	"./Lee Cooper Logo.png": 3427,
	"./Little Marcel Logo.png": 4513,
	"./Metro Boutique Logo.png": 9782,
	"./Pepe Jeans Logo.jpeg": 7005,
	"./Sally Miller Logo.png": 6151,
	"./Seppala Logo.jpeg": 1298,
	"./Simons Logo.png": 4012,
	"./Stud Man Logo.png": 6509,
	"./Top Secret Logo.jpg": 7558,
	"./V&d Logo.jpeg": 7138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9579;